export function getMax(a, b) {
  //获取最大值
  return a > b ? a : b;
}
export function getMin(a, b) {
  //获取最小值
  return a < b ? a : b;
}
export function deepCopy(data) {
  return JSON.parse(JSON.stringify(data));
}
export function formatDate(date, type = "yyyy-MM-dd HH:mm:ss") {
  const dateRegex = /^\d{8}/;
  if (dateRegex.test(date) && typeof date === "string") {
    date = date.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
  }
  const weekLabel = ["日", "一", "二", "三", "四", "五", "六"];
  const paddNum = function(num) {
    num += "";
    return num.replace(/^(\d)$/, "0$1");
  };
  date = new Date(date);
  const config = {
    yyyy: date.getFullYear(),
    M: date.getMonth() + 1,
    MM: paddNum(date.getMonth() + 1),
    d: date.getDate(),
    dd: paddNum(date.getDate()),
    H: date.getHours(),
    HH: paddNum(date.getHours()),
    m: date.getMinutes(),
    mm: paddNum(date.getMinutes()),
    s: date.getSeconds(),
    ss: paddNum(date.getSeconds()),
    ww: weekLabel[date.getDay()]
  };
  return type.replace(/([a-z])(\1)*/gi, m => config[m]);
}



// WEBPACK FOOTER //
// ./src/common/js/utils.js